import { Container, ContainerTitulo, TituloForm } from "./styles";
import { useQueryParams, StringParam } from "use-query-params";

//FallBack
import Fallback from "./Fallback";

// EMPRENDIMENTOS
import OndasPraia from "./Empreendimentos/OndasPraia";
import HotelNacional from "./Empreendimentos/HotelNacional";
import BuziosBeach from "./Empreendimentos/BuziosBeach";
import GoldenGramado from "./Empreendimentos/GoldenGramado";
import ChateauDuGolden from "./Empreendimentos/ChateauDuGolden";
import LaBas from "./Empreendimentos/LaBas";
import PraiasDoLago from "./Empreendimentos/PraiasDoLago";
import QuintaSantaBarbara from "./Empreendimentos/QuintaSantaBarbara";
import SalinasExclusive from "./Empreendimentos/SalinasExclusive";
import SalinasPremium from "./Empreendimentos/SalinasPremium";
import SalinasPark from "./Empreendimentos/SalinasPark";
import SolarPedraDaIlha from "./Empreendimentos/SolarPedraDaIlha";
import DomPedroLaguna from "./Empreendimentos/DomPedroLaguna";
import { Col, Row } from "antd";
import styled from "styled-components";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";



const ContainerSeta = styled.div`
  width: 100%;
  height: 100%;

  grid-column-start: 1;
  grid-row-start: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;


export default function ViewInfoEmpreendimentos() {
  const [queryParams] = useQueryParams({
    empreend: StringParam,
  });
  const empreendimento = () => {
    switch (queryParams.empreend) {
      case "Búzios Beach Resort":
        return <BuziosBeach />;
      case "Château Du Golden":
        return <ChateauDuGolden />;
      case "Dom Pedro Laguna":
        return <DomPedroLaguna />;
      case "Golden Gramado Resort Laghetto":
        return <GoldenGramado />;
      case "Hotel Nacional":
        return <HotelNacional />;
      case "La Bas":
        return <LaBas />;
      case "Ondas Praia Resort":
        return <OndasPraia />;
      case "Praias do Lago Eco Resort":
        return <PraiasDoLago />;
      case "Quinta Santa Barbara Eco Resort":
        return <QuintaSantaBarbara />;
      case "Salinas Exclusive Resort":
        return <SalinasExclusive />;
      case "Salinas Park Resort":
        return <SalinasPark />;
      case "Salinas Premium Resort":
        return <SalinasPremium />;
      case "Solar Pedra da Ilha":
        return <SolarPedraDaIlha />;

      default:
        return <Fallback />; // Fallback para quando o valor não corresponde a nenhum empreendimento
    }
  };
  return (
    <Container>
      <ContainerTitulo>
        <TituloForm>{queryParams.empreend}</TituloForm>
      </ContainerTitulo>
      <Row style={{ width: "100%" }}>
      <Col span={3} >
                <ContainerSeta>
                  <a href={`/cadastroCotas`}>
                    <ArrowBackIcon color="primary" />
                  </a>
                </ContainerSeta>
              </Col>
              <Col span={18}></Col>

      </Row>
    
      {empreendimento()}
    </Container>
  );
}
